import { type UiLibI18n } from '@myre/domain-i18n-wordings';
import { type Translated } from '@myre/common-i18n';
export type OrderOption<T> = {
  label: Translated;
  value: T;
  selected?: boolean;
};
export type PaginationOption = OrderOption<number>;

export enum NumberOfItemsPerPage {
  Small = 30,
  Medium = 60,
  Large = 120,
}

/**
 * The page sizes a list offers; the first entry is also the one it starts on.
 */
export function defaultPaginationOptions(
  wordings: UiLibI18n,
): PaginationOption[] {
  return [
    NumberOfItemsPerPage.Small,
    NumberOfItemsPerPage.Medium,
    NumberOfItemsPerPage.Large,
  ].map(value => ({
    value,
    label: wordings._library.pagination.perPage({
      bindings: { number: value },
    }),
  }));
}
